export const DEG_TO_RAD = Math.PI / 180;
export const CENTER_ANGLE = 90 * DEG_TO_RAD;
export const ROTATION_LIMIT_DESKTOP = 20 * DEG_TO_RAD;
export const ROTATION_LIMIT_MOBILE = 50 * DEG_TO_RAD;
export const CENTER_STEPS = 1.5;

export const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value));
export const smoothstep = (t: number) => t * t * (3 - 2 * t);

export function createMediaQuery(
  query: string,
): MediaQueryList | { matches: boolean; addListener: () => void; removeListener: () => void } {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return { matches: false, addListener: () => {}, removeListener: () => {} };
  }

  return window.matchMedia(query);
}

export function addMediaQueryListener(
  mediaQuery:
    | MediaQueryList
    | { addEventListener?: (type: string, handler: () => void) => void; addListener?: (handler: () => void) => void },
  handler: () => void,
): void {
  if (typeof (mediaQuery as MediaQueryList).addEventListener === 'function') {
    (mediaQuery as MediaQueryList).addEventListener('change', handler);
  } else if (typeof (mediaQuery as { addListener?: (handler: () => void) => void }).addListener === 'function') {
    (mediaQuery as { addListener: (handler: () => void) => void }).addListener(handler);
  }
}

export interface ILayout {
  radius: number;
  centerOffset: number;
  cardSize: number;
  stepDeg: number;
  stepRad: number;
  startAngle: number;
  maxDelta: number;
}

export interface IIntro {
  active: boolean;
  start: number;
  duration: number;
  from: number;
  peak1: number;
  peak2: number;
  to: number;
}

export const CONFIG = {
  cardCount: 9,
  maxSpeed: 0.0025,
  speedFactor: 0.0000875,
  damping: 0.92,
  inertia: 0.985,
  scaleStep: 0.75,
  maxBlur: 4,
  stepDegFallback: 9.54,
};
